import React from "react";
import "./DashBoard.css";
import Layout from "../components/Layout";
import Payment from "../components/Dashboard/Payment";
import Api from "../components/Dashboard/Api";
import Plan from "../components/Dashboard/Plan";
import Account from "../components/Dashboard/Account";
import Earn from "../components/Dashboard/Earn";
import { Route, Switch, useRouteMatch, NavLink } from "react-router-dom";
import { BrowserRouter } from "react-router-dom";
import NotFound from "./NotFound";
export default function DashBoard() {
  const { path, url } = useRouteMatch();
  console.log(path, url);
  const dashboardData = [
    {
      id: "001",
      title: "Credits & Plan",
      name: "Plan",
      component: <Plan />,
    },
    {
      id: "002",
      title: "Payment & Billing",
      name: "Payment",
      component: <Payment />,
    },
    {
      id: "003",
      title: "API Keys",
      name: "Api",
      component: <Api />,
    },
    {
      id: "004",
      title: "Earn credits",
      name: "Earn",
      component: <Earn />,
    },
    {
      id: "005",
      title: "Account Settings",
      name: "Account",
      component: <Account />,
    },
  ];
  return (
    <Layout>
      <div className="dashboard-container">
        <h2 style={{margin:"1rem",color: "#54616c",fontSize:"40px"}}>My Dashboard</h2>
        <p style={{color: "#54616c",fontSize:"20px"}}>Thorpham</p>
        <div className="dashboard-content">
          <ul>
            {dashboardData.map((item) => {
              return (
                <NavLink style={{textDecoration:"none",color: "#54616c"}}
                  key={item.id}
                  className="nav-list-items"
                  activeClassName="navlink-selected"
                  to={`/dashboard/${item.name}`}
                >
                  {item.title}
                </NavLink>
              );
            })}
          </ul>
          <Switch>
            <Route path={`${url}`} exact>
              <Plan />
            </Route>
            <Route path={`${url}/Plan`} exact>
              <Plan />
            </Route>
            <Route path={`${url}/Earn`} exact>
              <Earn />
            </Route>
            <Route path={`${url}/Account`} exact>
              <Account />
            </Route>
            <Route path={`${url}/Payment`} exact>
              <Payment />
            </Route>
            <Route path={`${url}/Api`} exact>
              <Api />
            </Route>
            <Route path={`${url}/*`} >
              <NotFound />
            </Route>
          </Switch>
        </div>
      </div>

      {/* <BrowserRouter basename={`/${path}`}>

         <Switch>
            <Route path="/Plan">
               <Plan />
            </Route>
            <Route path="/Earn">
               <Earn />
            </Route>
            <Route path={`${url}/Account`}>
               <Account />
            </Route>
            <Route path={`${url}/Payment`}>
               <Payment />
            </Route>
            <Route path={`${url}/Api`}>
               <Api />
            </Route>
         </Switch>
       </BrowserRouter> */}
    </Layout>
  );
}
